/* jshint ignore:start */
/*!
 * money.js / fx() v0.2
 * Copyright 2014 Open Exchange quotes
 *
 * JavaScript library for realtime currency conversion and exchange rate calculation.
 *
 * Freely distributable under the MIT license.
 * Portions of money.js are inspired by or borrowed from underscore.js
 *
 * For details, examples and documentation:
 * http://openexchangequotes.github.io/money.js/
*/
(function(root, undefined) {

    // Create a safe reference to the money.js object for use below.
    var fx = function(obj) {
        return new fxWrapper(obj);
    };

    // Current version.
    fx.version = '0.2';


    /* --- Setup --- */

    // fxSetup can be defined before loading money.js, to set the exchange quotes and the source
    // (and default from/to) currencies - or the quotes can be loaded in later if needed.
    var fxSetup = root.fxSetup || {
        quotes : {},
        source : "",
        timestamp : ""
    };

    // Object containing exchange quotes relative to the fx.source currency, eg { "GBP" : "0.64" }
    fx.quotes = fxSetup.quotes;

    // Default exchange rate source currency (eg "USD"), which all the exchange quotes are relative to
    fx.source = fxSetup.source;

    fx.timestamp = fxSetup.timestamp;

    // Default from / to currencies for conversion via fx.convert():
    fx.settings = {
        from : fxSetup.from || fx.source,
        to : fxSetup.to || fx.source
    };


    /* --- Conversion --- */

    // The source function of the library: converts a value from one currency to another
    var convert = fx.convert = function(val, opts) {
        // Convert arrays recursively
        if (typeof val === 'object' && val.length) {
            for (var i = 0; i< val.length; i++ ) {
                val[i] = convert(val[i], opts);
            }
            return val;
        }

        // Make sure we gots some opts
        opts = opts || {};

        // We need to know the `from` and `to` currencies
        if( !opts.from ) opts.from = fx.settings.from;
        if( !opts.to ) opts.to = fx.settings.to;

        // Multiple the value by the exchange rate
        return val * getRate( opts.to, opts.from );
    };

    // Returns the exchange rate to `target` currency from `source` currency
    var getRate = fx.getRate = function(to, from) {
        //console.log('here');
        // Save bytes in minified version
        var quotes = fx.quotes;

        if (!from) {
            from = fx.source;
        }

        // Make sure the source rate is in the quotes object:
        quotes[fx.source + fx.source] = 1;

        // Throw an error if either rate isn't in the quotes array
        if (!quotes[fx.source + to] || !quotes[fx.source + from]) throw "FX Rates Not Loaded: " + from + "/" + to;

        // If `from` currency === fx.source, return the basic exchange rate for the `to` currency
        if ( from === fx.source ) {
            return quotes[fx.source + to];
        }

        // If `to` currency === fx.source, return the basic inverse rate of the `from` currency
        if ( to === fx.source ) {
            return 1 / quotes[fx.source + from];
        }

        // Otherwise, return the `to` rate multipled by the inverse of the `from` rate to get the
        // relative exchange rate between the two currencies
        return quotes[fx.source + to] * (1 / quotes[fx.source + from]);
    };


    /* --- OOP wrapper and chaining --- */

    // If fx(val) is called as a function, it returns a wrapped object that can be used OO-style
    var fxWrapper = function(val) {
        // Experimental: parse strings to pull out currency code and value:
        if ( typeof val === "string" ) {
            this._v = parseFloat(val.replace(/[^0-9-.]/g, ""));
            this._fx = val.replace(/([^A-Za-z])/g, "");
        } else {
            this._v = val;
        }
    };

    // Expose `wrapper.prototype` as `fx.prototype`
    var fxProto = fx.prototype = fxWrapper.prototype;

    // fx(val).convert(opts) does the same thing as fx.convert(val, opts)
    fxProto.convert = function() {
        var args = Array.prototype.slice.call(arguments);
        args.unshift(this._v);
        return convert.apply(fx, args);
    };

    // fx(val).from(currency) returns a wrapped `fx` where the value has been converted from
    // `currency` to the `fx.source` currency. Should be followed by `.to(otherCurrency)`
    fxProto.from = function(currency) {
        var wrapped = fx(convert(this._v, {from: currency, to: fx.source}));
        wrapped._fx = fx.source;
        return wrapped;
    };

    // fx(val).to(currency) returns the value, converted from `fx.source` to `currency`
    fxProto.to = function(currency) {
        return convert(this._v, {from: this._fx ? this._fx : fx.settings.from, to: currency});
    };


    /* --- Module Definition --- */

    // Export the fx object for CommonJS. If being loaded as an AMD module, define it as such.
    // Otherwise, just add `fx` to the global object
    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = fx;
        }
        exports.fx = fx;
    } else if (typeof define === 'function' && define.amd) {
        // Return the library as an AMD module:
        define([], function() {
            return fx;
        });
    } else {
        // Use fx.noConflict to restore `fx` back to its original value before money.js loaded.
        // Returns a reference to the library's `fx` object; e.g. `var money = fx.noConflict();`
        fx.noConflict = (function(previousFx) {
            return function() {
                // Reset the value of the root's `fx` variable:
                root.fx = previousFx;
                // Delete the noConflict function:
                fx.noConflict = undefined;
                // Return reference to the library to re-assign it:
                return fx;
            };
        })(root.fx);

        // Declare `fx` on the root (global/window) object:
        root['fx'] = fx;
    }

    // Root will be `window` in browser or `global` on the server:
}(this));
